import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Truck } from "lucide-react";

// Cascading make -> model -> year(generation) picker. Calls onResolve({bolt_pattern, diameters, label}).
export const VehiclePicker = ({ onResolve, onReset }) => {
  const [vehicles, setVehicles] = useState(null);
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [genIdx, setGenIdx] = useState("");

  useEffect(() => { api.get("/vehicles").then((r) => setVehicles(r.data)); }, []);

  const models = make && vehicles ? Object.keys(vehicles[make]) : [];
  const gens = make && model && vehicles ? vehicles[make][model] : [];

  const pickMake = (m) => { setMake(m); setModel(""); setGenIdx(""); onReset?.(); };
  const pickModel = (m) => {
    setModel(m); setGenIdx("");
    const g = vehicles[make][m];
    if (g.length === 1) { setGenIdx("0"); onResolve({ ...g[0], label: `${make} ${m}` }); }
    else onReset?.();
  };
  const pickGen = (i) => { setGenIdx(i); const g = gens[parseInt(i)]; onResolve({ ...g, label: `${make} ${model} ${g.years}` }); };

  if (!vehicles) return null;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider text-muted-foreground font-bold">
        <Truck className="w-3.5 h-3.5 text-blaze" /> Shop by your truck
      </div>
      <Select value={make} onValueChange={pickMake}>
        <SelectTrigger data-testid="vehicle-make" className="bg-[#0A0A0A] border-border rounded-sm h-9 text-sm"><SelectValue placeholder="Select make" /></SelectTrigger>
        <SelectContent className="bg-[#141414] border-border">
          {Object.keys(vehicles).map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}
        </SelectContent>
      </Select>
      {make && (
        <Select value={model} onValueChange={pickModel}>
          <SelectTrigger data-testid="vehicle-model" className="bg-[#0A0A0A] border-border rounded-sm h-9 text-sm"><SelectValue placeholder="Select model" /></SelectTrigger>
          <SelectContent className="bg-[#141414] border-border">
            {models.map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}
          </SelectContent>
        </Select>
      )}
      {model && gens.length > 1 && (
        <Select value={genIdx} onValueChange={pickGen}>
          <SelectTrigger data-testid="vehicle-year" className="bg-[#0A0A0A] border-border rounded-sm h-9 text-sm"><SelectValue placeholder="Select year range" /></SelectTrigger>
          <SelectContent className="bg-[#141414] border-border">
            {gens.map((g, i) => <SelectItem key={i} value={String(i)} className="spec-block">{g.years}</SelectItem>)}
          </SelectContent>
        </Select>
      )}
    </div>
  );
};
